import { userAxios } from 'APIs';
import { useParams } from 'react-router-dom';
import { createContext, useState, useEffect, ReactNode } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

interface PartnerDetails {
  chef: any;
  // Define expected fields from API here
  name?: string;
  id?: string;
  // ...other fields
}
interface PartnerDetailsState {
  isLoading: boolean;
  status: number;
  error: boolean;
  data: PartnerDetails;
}
interface PartnerContextProps {
  partnerDetails: PartnerDetailsState;
}

const PARTNER_DATA_MODAL: PartnerDetailsState = {
  isLoading: true,
  status: 0,
  error: false,
  data: {
    chef: undefined,
  },
};

export const PartnerContextDetails = createContext<
  PartnerContextProps | undefined
>(undefined);

export const PartnerDetailsProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [partnerDetails, setPartnerDetails] =
    useState<PartnerDetailsState>(PARTNER_DATA_MODAL);
  const { partnerId } = useParams(); // ✅ get partnerId from route
  const navigate = useNavigate();

  useEffect(() => {
  if (!partnerId) return;

  const fetchPartnerData = async () => {
    try {
      const response = await userAxios.get(`/chefs/${partnerId}`);
      const {
        data: { error, data },
        status,
      } = response;

      setPartnerDetails({
        isLoading: false,
        status,
        error,
        data,
      });
    } catch (error) {
      console.log("Error fetching partner:", error);

      if (axios.isAxiosError(error) && error.response?.status === 401) {
        localStorage.clear();
        navigate("/");
        return;
      }

      setPartnerDetails((prev) => ({
        ...prev,
        isLoading: false,
        error: true,
      }));
    }
  };

  fetchPartnerData();
}, [partnerId, navigate]);


  return (
    <PartnerContextDetails.Provider value={{ partnerDetails }}>
      {children}
    </PartnerContextDetails.Provider>
  );
};
